/**
 * Connects the existing email-signup form markup (blocks/email-signup.liquid)
 * to an external email service (e.g. Kit) instead of Shopify's own native
 * customer form, without changing any of its existing HTML/CSS. Only loaded
 * when a block instance has use_external_provider enabled - never touches
 * any other instance of this shared block (e.g. the password page's, which
 * keeps Shopify's native form untouched).
 *
 * Submits with the browser's standard application/x-www-form-urlencoded
 * encoding (matching what a plain, un-enhanced HTML form would send, which
 * is what these providers' own embed forms rely on) rather than
 * multipart/form-data, which fetch would otherwise default to for a
 * FormData body.
 */
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-external-email-form')) return;

  event.preventDefault();

  const errorEl = form.querySelector('.email-signup__message[id^="Email-signup__message-error-"]');
  const successEl = form.querySelector('.email-signup__message[id^="Email-signup__message-success-"]');
  const input = form.querySelector('input[type="email"]');
  const button = form.querySelector('.email-signup__button');

  errorEl?.setAttribute('hidden', '');
  successEl?.setAttribute('hidden', '');
  input?.removeAttribute('aria-invalid');
  input?.removeAttribute('aria-describedby');

  if (button instanceof HTMLButtonElement) button.disabled = true;

  try {
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form).entries()) {
      params.append(key, String(value));
    }

    const response = await fetch(form.action, {
      method: form.method || 'POST',
      body: params,
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

    if (successEl) {
      successEl.removeAttribute('hidden');
      successEl.focus();
    }
    if (input) input.setAttribute('aria-describedby', successEl?.id ?? '');
    form.reset();
  } catch (error) {
    if (errorEl) {
      errorEl.removeAttribute('hidden');
      errorEl.focus();
    }
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', errorEl?.id ?? '');
    }
  } finally {
    if (button instanceof HTMLButtonElement) button.disabled = false;
  }
});
